<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-address-card', fontSet: 'fad'}"
	[headerText]="'Peer Practice Participant'"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<sim-user-details [user]="displayConfig().participant" dialogContent>
		<ng-container extra>
			<mat-divider />
			<section class="extra">
				<div>
					<label class="secondary">
						<mat-icon fontIcon="fa-users" fontSet="fas" inline />
						{{ T.LABEL_SUBGROUP | translate }} {{ T.LABEL_NAME | translate }}
					</label>
					<span>{{ displayConfig().subgroupName }}</span>
				</div>
				<mat-divider vertical />
				<div>
					<label class="secondary">
						<mat-icon fontIcon="fa-door-open" fontSet="fas" inline />
						{{ T.LABEL_STATION | translate }},
						{{ T.LABEL_ROOM | translate }}
					</label>
					<span>
						<div class="stationIndex mat-elevation-z1">
							{{ displayConfig().stationIndex }}
						</div>
						{{ displayConfig().roomName }}
					</span>
				</div>
			</section>
		</ng-container>
		@if (isConfirmation()) {
			<ng-container actions>
				<mat-button-toggle-group
					(change)="setParticipantState($event.value)"
					hideSingleSelectionIndicator
					class="buttonToggleGroup"
				>
					@let isReady = participantState() === SessionRunParticipantStateType.Ready;
					<mat-button-toggle [checked]="isReady" [value]="ParticipantState.CheckedIn">
						@if (isReady) {
							<mat-icon fontIcon="fa-check" fontSet="fal" />
						} @else {
							<mat-icon fontIcon="fa-user-check" fontSet="fa" />
						}
						{{ T.ENUM_PARTICIPANT_STATE_PRESENT | translate }}
					</mat-button-toggle>
					<mat-button-toggle [checked]="!isReady" [value]="ParticipantState.Absent">
						@if (isReady) {
							<mat-icon fontIcon="fa-check" fontSet="fal" />
						} @else {
							<mat-icon fontIcon="fa-user-times" fontSet="fa" />
						}
						{{ T.ENUM_PARTICIPANT_STATUS_ABSENT | translate }}
					</mat-button-toggle>
				</mat-button-toggle-group>
			</ng-container>
		}
	</sim-user-details>
</sim-basic-material-dialog>
